module.exports = __webpack_public_path__ + "img/portal-animation.d431ac83.svg";